<template>
  <div>
    <!-- 上传 -->
    <div class="mtb" v-if="!isShowYL">
      <!-- 1行 -->
      <div class="rows">
        <div class="rowLeft">1,下载运单导入模板并填写信息</div>
        <div class="rowRight">
          <el-button class="btns glo_bgcMainColor" @click="downLoadYD(1)">下载运单模板</el-button>
          <!-- <el-button class="btns glo_bgcMainColor" @click="downLoadYD(2)"
            >下载运单货物模板</el-button
          >-->
        </div>
      </div>

      <div class="rows">
        <div class="rowLeft">2,上传填写完整的运单模板</div>
        <div class="rowRight">
          <el-button class="btns" @click="uploadMaterial(1)">上传文件</el-button>
          <div class="filenames">{{ fileName1 }}</div>
          <div v-if="fileName1">
            <i v-if="!isFileSuccess_1" class="el-icon-loading"></i>
            <i v-else style="color: #00c297" class="el-icon-success"></i>
          </div>
        </div>
      </div>
      <!-- <div class="rows">
        <div class="rowLeft">3,上传填写完整的运单货物模板</div>
        <div class="rowRight">
          <el-button class="btns" @click="uploadMaterial(2)"
            >上传文件</el-button
          >
          <div class="filenames">{{ fileName2 }}</div>
          <div v-if="fileName2">
            <i v-if="!isFileSuccess_2" class="el-icon-loading"></i>
            <i v-else style="color: #00c297" class="el-icon-success"></i>
          </div>
        </div>
      </div>-->
      <div class="rows">
        <div class="rowLeft"></div>
        <div class="rowRight">
          <el-button class="btns glo_bgcMainColor" @click="goDetails">导入预览</el-button>
          <el-button class="btns" @click="ResetBtns">重置</el-button>
        </div>
      </div>
    </div>

    <!-- 预览 -->
    <div class="pagesBox" v-if="isShowYL">
      <div style="height: 60px; width: 100%"></div>
      <div class="topBtns">
        <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="saveBtns">确认导入</el-button>
        <el-button style="margin-top: 10px" class @click="isShowYL = false">关闭预览</el-button>
      </div>

      <!-- 表格 -->
      <div class="glo_Table">
        <!-- 运单信息 -->
        <!-- <div class="tablerTitle">运单信息</div> -->
        <el-table :height="tableHeigth" header-align="center" ref="mytable" :data="tableData" border stripe :highlight-current-row="true" show-summary :summary-method="getSummaries">
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <!-- <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column>-->
          <template v-for="(item, index) in myTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item.field == 'isError' && item.isShow"
            >
              <template slot-scope="scope">
                <div class="errorClaaa" v-if="scope.row.isError == 1">是</div>
                <div v-else>否</div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-else-if="item.field == 'errorReason' && item.isShow"
            >
              <template slot-scope="scope">
                <div class="errorClaaa">{{ scope.row.errorReason }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-else-if="item && item.isShow"
            >
              <el-table-column
                v-for="(item2, idx2) in item.childLists"
                :key="idx2"
                :label="item2.name"
                :prop="item2.field"
                align="center"
                :show-overflow-tooltip="true"
                :min-width="item2.width"
                :data-isTotal="item2.isTotal"
              ></el-table-column>
            </el-table-column>
          </template>
          <el-table-column fixed="right" label="操作" min-width="120px">
            <template slot-scope="scope">
              <div class="tabRightBtns">
                <el-button class="rbtns" @click.stop="editBtns(scope.row, scope.$index)">修改</el-button>
                <el-button class="rbtns" @click.stop="delBtns(scope.row, scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 货物 -->
        <!-- <div class="tablerTitle" style="margin-top: 20px">货物信息</div>
        <el-table
          header-align="center"
          ref="mytable2"
          :data="tableData2"
          border
          stripe
          :highlight-current-row="true"
          show-summary
          :summary-method="getSummaries2"
        >
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          >
          </el-table-column>
          <template v-for="(item, index) in myTableHeard2">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item.field == 'isError' && item.isShow"
            >
              <template slot-scope="scope">
                <div class="errorClaaa" v-if="scope.row.isError == 1">是</div>
                <div v-else>否</div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-else-if="item.field == 'errorReason' && item.isShow"
            >
              <template slot-scope="scope">
                <div class="errorClaaa">{{ scope.row.errorReason }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-else-if="item && item.isShow"
            >
            </el-table-column>
          </template>

          <el-table-column fixed="right" label="操作" min-width="120px">
            <template slot-scope="scope">
              <div class="tabRightBtns">
                <el-button
                  class="rbtns"
                  @click.stop="editBtns2(scope.row, scope.$index)"
                  >修改</el-button
                >
                <el-button
                  class="rbtns"
                  @click.stop="delBtns2(scope.row, scope.$index)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>-->
      </div>
    </div>

    <!-- 上传组件 -->
    <input type="file" style="display: none" ref="file" @click="
        (e) => {
          e.target.value = '';
        }
      " @change="getFileData" />
    <!-- 上传运单模板 才用到   fileNameId -->
    <div v-if="1 == 2">
      <div>上传运单模板</div>
      <uploadimgs @input="changeFileList" :fileNameLists="fileNameLists" :limit="1"></uploadimgs>

      <!-- <div style="margin-top: 20px">上传运单货物模板</div>
      <uploadimgs
        @input="changeFileList2"
        :fileNameLists="fileNameLists2"
        :limit="1"
      ></uploadimgs>-->
    </div>

    <!-- 弹窗 修改运单 -->
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1('dialogFormRef1')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" v-if="isShowDialog1" ref="dialogFormRef1" :model="dialogForm1" label-width="100px">
          <el-form-item class="dialogFormItems queryItems" label="是否报错:">
            <el-select clearable filterable v-model="dialogForm1.isError" placeholder="请选择" disabled>
              <el-option v-for="(item, index) in isErrorList" :key="index" :label="item.name" :value="item.val + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dialogForm1.isError == 1" class="dislogFormTextarea" prop="errorReason" label="错误原因:">
            <el-input type="textarea" rows="2" v-model="dialogForm1.errorReason"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="waybillNumber" label="运单号:">
            <el-input type="text" v-model="dialogForm1.waybillNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="customerNumber" label="开单客户编号:">
            <el-input type="text" v-model="dialogForm1.customerNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="customerName" label="开单客户名称:">
            <el-input type="text" v-model="dialogForm1.customerName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="customerOrderNumber" label="客户单号:">
            <el-input type="text" v-model="dialogForm1.customerOrderNumber"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="businessDeptName" label="业务部门:">
            <el-input type="text" v-model="dialogForm1.businessDeptName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="businessDeptNumber" label="业务部门编号:">
            <el-input type="text" v-model="dialogForm1.businessDeptNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="transportMethod" label="业务类型:">
            <el-input type="text" v-model="dialogForm1.transportMethod"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="businessDate" label="业务日期:">
            <el-date-picker v-model="dialogForm1.businessDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="takeTime" label="提货日期:">
            <el-date-picker v-model="dialogForm1.takeTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="deliveryTime" label="提货日期:">
            <el-date-picker v-model="dialogForm1.deliveryTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="receiveMethod" label="提货方式:">
            <el-input type="text" v-model="dialogForm1.receiveMethod"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sendMethod" label="送货方式:">
            <el-input type="text" v-model="dialogForm1.sendMethod"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="requireName" label="回单方式:">
            <el-input type="text" v-model="dialogForm1.requireName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="requireCount" label="回单份数:">
            <el-input type="text" v-model="dialogForm1.requireCount"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="waybillType" label="货物类型:">
            <el-input type="text" v-model="dialogForm1.waybillType"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="endDeptName" label="终端网点:">
            <el-input type="text" v-model="dialogForm1.endDeptName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="endDeptNumber" label="终端网点编号:">
            <el-input type="text" v-model="dialogForm1.endDeptNumber"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="waybillRemarks" label="运单备注:">
            <el-input type="text" v-model="dialogForm1.waybillRemarks"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="receiveContacts" label="收货人:">
            <el-input type="text" v-model="dialogForm1.receiveContacts"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="receiveCompany" label="收货单位:">
            <el-input type="text" v-model="dialogForm1.receiveCompany"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="receivePhone" label="收货电话:">
            <el-input type="text" v-model="dialogForm1.receivePhone"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="receiveProvinceName" label="收货省份:">
            <el-input type="text" v-model="dialogForm1.receiveProvinceName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="receiveCityName" label="收货城市:">
            <el-input type="text" v-model="dialogForm1.receiveCityName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="receiveAreaName" label="收货区县:">
            <el-input type="text" v-model="dialogForm1.receiveAreaName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="receiveAddress" label="收货详细地址:">
            <el-input type="text" v-model="dialogForm1.receiveAddress"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="contacts" label="发货人:">
            <el-input type="text" v-model="dialogForm1.contacts"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="company" label="发货单位:">
            <el-input type="text" v-model="dialogForm1.company"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="tel" label="发货电话:">
            <el-input type="text" v-model="dialogForm1.tel"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="provinceName" label="发货省:">
            <el-input type="text" v-model="dialogForm1.provinceName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="cityName" label="发货城市:">
            <el-input type="text" v-model="dialogForm1.cityName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="areaName" label="发货区县:">
            <el-input type="text" v-model="dialogForm1.areaName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="address" label="发货详细地址:">
            <el-input type="text" v-model="dialogForm1.address"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="goodsNumber" label="货物编号:">
            <el-input type="text" v-model="dialogForm1.goodsNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="goodsName" label="货物名称:">
            <el-input type="text" v-model="dialogForm1.goodsName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="itemCategoryName" label="品类:">
            <el-input type="number" v-model="dialogForm1.itemCategoryName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="packageName" label="包装:">
            <el-input type="number" v-model="dialogForm1.packageName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="packageCout" label="件数:">
            <el-input type="number" v-model="dialogForm1.packageCout"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="grossWeight" label="毛重/KG:">
            <el-input type="number" v-model="dialogForm1.grossWeight"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="netWeight" label="净重/KG:">
            <el-input type="number" v-model="dialogForm1.netWeight"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="volumeWeight" label="体积重量:">
            <el-input type="number" v-model="dialogForm1.volumeWeight"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="billingWeight" label="计费取值:">
            <el-input type="number" v-model="dialogForm1.billingWeight"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="volume" label="体积/m³:">
            <el-input type="number" v-model="dialogForm1.volume"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="specs" label="规格:">
            <el-input type="number" v-model="dialogForm1.specs"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="unitPrice" label="单价:">
            <el-input type="number" v-model="dialogForm1.unitPrice"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="settlementMethod" label="付款方式:">
            <el-input type="text" v-model="dialogForm1.settlementMethod"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isInvoice" label="是否开票:">
            <el-input type="text" v-model="dialogForm1.isInvoice"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="taxes" label="开票税点:">
            <div class="disFlex">
              <el-input v-model="dialogForm1.taxes" placeholder="请输入" clearable type="number" @input="getTaxes()"></el-input>
              <div>(%)</div>
            </div>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="basicFreight" label="基本运费:">
            <el-input type="text" v-model="dialogForm1.basicFreight"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="takeFee" label="提货费:">
            <el-input type="text" v-model="dialogForm1.takeFee"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sendFee" label="送货费:">
            <el-input type="text" v-model="dialogForm1.sendFee"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="otherFee" label="其他费用:">
            <el-input type="text" v-model="dialogForm1.otherFee"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="totalFreight" label="运费合计:">
            <el-input type="text" v-model="dialogForm1.totalFreight"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="billingAmount" label="开单金额:">
            <el-input type="text" v-model="dialogForm1.billingAmount"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="agentAmount" label="代收货款:">
            <el-input type="text" v-model="dialogForm1.agentAmount"></el-input>
          </el-form-item>
          <!-- <el-form-item
            class="dialogFormItems"
            prop="customerName"
            label="应收结算单位:"
          >
            <el-input type="text" v-model="dialogForm1.customerName"></el-input>
          </el-form-item>-->
          <el-form-item class="dialogFormItems" prop="receivedAmount" label="到付金额:">
            <el-input type="text" v-model="dialogForm1.receivedAmount"></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="itemServiceFeeRemarks" label="费项说明备注:">
            <el-input type="text" v-model="dialogForm1.itemServiceFeeRemarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 修改货物 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef2')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" v-if="isShowDialog2" ref="dialogFormRef2" :model="dialogForm2" label-width="100px">
          <el-form-item class="dialogFormItems queryItems" label="是否报错:">
            <el-select clearable filterable v-model="dialogForm2.isError" placeholder="请选择" disabled>
              <el-option v-for="(item, index) in isErrorList" :key="index" :label="item.name" :value="item.val + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dialogForm2.isError == 1" class="dislogFormTextarea" prop="errorReason" label="错误原因:">
            <el-input type="textarea" rows="2" v-model="dialogForm2.errorReason"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="waybillNumber" label="运单号:">
            <el-input type="text" v-model="dialogForm2.waybillNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="contacts" label="发货人:">
            <el-input type="text" v-model="dialogForm2.contacts"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="company" label="发货单位:">
            <el-input type="text" v-model="dialogForm2.company"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="tel" label="发货电话:">
            <el-input type="text" v-model="dialogForm2.tel"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="provinceName" label="发货省份:">
            <el-input type="text" v-model="dialogForm2.provinceName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="cityName" label="发货城市:">
            <el-input type="text" v-model="dialogForm2.cityName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="areaName" label="发货区县:">
            <el-input type="text" v-model="dialogForm2.areaName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="address" label="发货详细地址:">
            <el-input type="text" v-model="dialogForm2.address"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="goodsNumber" label="货物编号:">
            <el-input type="text" v-model="dialogForm2.goodsNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="goodsName" label="货物名称:">
            <el-input type="text" v-model="dialogForm2.goodsName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="itemCategoryName" label="品类:">
            <el-input type="text" v-model="dialogForm2.itemCategoryName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="packageName" label="包装:">
            <el-input type="text" v-model="dialogForm2.packageName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="packageCout" label="件数:">
            <el-input type="text" v-model="dialogForm2.packageCout"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="grossWeight" label="重量/KG:">
            <el-input type="text" v-model="dialogForm2.grossWeight"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="volume" label="体积/m³:">
            <el-input type="text" v-model="dialogForm2.volume"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="specs" label="规格:">
            <el-input type="text" v-model="dialogForm2.specs"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  components: {
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      listType: "text",
      fileName1: "",
      fileName2: "",
      inputNum: "",
      isFileSuccess_1: false,
      isFileSuccess_2: false,
      itemFile: "",
      waybillFile: "",

      isShowYL: false, //是否预览

      // 预览的
      tableHeigth: "75vh",
      myTableHeard: [
        {
          name: "是否错误",
          field: "isError",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "错误原因",
          field: "errorReason",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "客户信息",
          field: "",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [
            {
              name: "开单客户编号",
              field: "customerNumber",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "开单客户名称",
              field: "customerName	",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "客户单号",
              field: "customerOrderNumber",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "业务部门",
              field: "businessDeptName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "业务部门编号",
              field: "businessDeptNumber",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
          ],
        },
        {
          name: "运单信息",
          field: "",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [
            {
              name: "业务类型",
              field: "transportMethod",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "提货方式",
              field: "receiveMethod",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "送货方式",
              field: "sendMethod",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },

            {
              name: "回单方式",
              field: "requireName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "回单份数",
              field: "requireCount",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "货物类型",
              field: "waybillType",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "终端网点",
              field: "endDeptName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "终端网点编号",
              field: "endDeptNumber",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "运单备注",
              field: "waybillRemarks",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
          ],
        },
        {
          name: "收货信息",
          field: "",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [
            {
              name: "收货人",
              field: "receiveContacts",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "收货单位",
              field: "receiveCompany",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "收货电话",
              field: "receivePhone",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "收货省份",
              field: "receiveProvinceName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "收货城市",
              field: "receiveCityName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "收货区县",
              field: "receiveAreaName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "收货详细地址",
              field: "receiveAddress",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
          ],
        },

        {
          name: "发货地址信息",
          field: "",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [
            {
              name: "发货人",
              field: "contacts",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "发货单位",
              field: "company",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "发货电话",
              field: "tel",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "发货省份",
              field: "provinceName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "发货城市",
              field: "cityName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "发货区县",
              field: "areaName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "发货详细地址",
              field: "address",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
          ],
        },
        {
          name: "货物信息",
          field: "",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [
            {
              name: "货物编号",
              field: "goodsNumber",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "货物名称",
              field: "goodsName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "品类",
              field: "itemCategoryName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },

            {
              name: "包装",
              field: "packageName",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "件数",
              field: "packageCout",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "毛重/KG",
              field: "grossWeight",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "净量/KG",
              field: "netWeight",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "体积重量",
              field: "volumeWeight",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "计费取值",
              field: "billingWeight",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "体积/m³",
              field: "volume",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "规格",
              field: "specs",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "单价",
              field: "unitPrice",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
          ],
        },
        {
          name: "财务信息",
          field: "",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [
            {
              name: "付款方式",
              field: "settlementMethod",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "是否开票",
              field: "isInvoice",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "开票税点",
              field: "taxes",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "基本运费",
              field: "basicFreight",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "提货费",
              field: "takeFee",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "送货费",
              field: "sendFee",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "其他费用",
              field: "otherFee",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "运费合计",
              field: "totalFreight",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "开单金额",
              field: "billingAmount",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "代收货款",
              field: "agentAmount",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            // {
            //   name: "应收结算单位",
            //   field: "customerName",
            //   width: "120",
            //   sort: 1,
            //   isShow: true,
            //   isTotal: false,
            //   isSort: true,
            //   childLists: [],
            // },
            {
              name: "到付金额",
              field: "receivedAmount",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
            {
              name: "费项说明备注",
              field: "itemServiceFeeRemarks",
              width: "120",
              sort: 1,
              isShow: true,
              isTotal: false,
              isSort: true,
              childLists: [],
            },
          ],
        },

        // {
        //   name: "结算单位编号",
        //   field: "customerNumber",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },

        // {
        //   name: "业务日期",
        //   field: "businessDate",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },

        // {
        //   name: "业务部门",
        //   field: "businessDeptName",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },

        // {
        //   name: "终端网点",
        //   field: "endDeptName",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
      ],
      myTableHeard2: [
        {
          name: "是否错误",
          field: "isError",
          width: "80",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "错误原因",
          field: "errorReason",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "提货地址编号",
        //   field: "aaaaaaaa",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
      ],
      tableData: [],
      tableData2: [],
      totalArr: [],
      totalArr2: [],

      // 弹窗1
      diaWidth1: "80%",
      dialogTitle1: "修改运单信息",
      isShowDialog1: false,
      dialogForm1: {
        isError: "",
        errorReason: "",
        waybillNumber: "",
        customerNumber: "",
        customerName: "",
        customerOrderNumber: "",
        businessDeptName: "",
        businessDeptNumber: "",
        transportMethod: "",
        businessDate: "",
        takeTime: "",
        deliveryTime: "",
        receiveMethod: "",
        sendMethod: "",
        requireName: "",
        requireCount: "",
        waybillType: "",
        endDeptName: "",
        endDeptNumber: "",
        waybillRemarks: "",
        receiveContacts: "",
        receiveCompany: "",
        receivePhone: "",
        receiveProvinceName: "",
        receiveCityName: "",
        receiveAreaName: "",
        receiveAddress: "",
        contacts: "",
        company: "",
        tel: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        goodsNumber: "",
        goodsName: "",
        itemCategoryName: "",
        packageName: "",
        packageCout: "",
        grossWeight: "",
        netWeight: "",
        volumeWeight: "",
        billingWeight: "",
        volume: "",
        specs: "",
        unitPrice: "",
        settlementMethod: "",
        isInvoice: "",
        taxes: "",
        basicFreight: "",
        takeFee: "",
        sendFee: "",
        otherFee: "",
        totalFreight: "",
        billingAmount: "",
        agentAmount: "",
        receivedAmount: "",
        customerName: "",
        itemServiceFeeRemarks: "",
      },
      idx1: null,
      // 弹窗2
      diaWidth2: "80%",
      dialogTitle2: "修改运单货物信息",
      isShowDialog2: false,
      dialogForm2: {
        isError: "",
        errorReason: "",
        waybillNumber: "",
        contacts: "",
        company: "",
        tel: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        goodsNumber: "",
        goodsName: "",
        itemCategoryName: "",
        packageName: "",
        packageCout: "",
        grossWeight: "",
        volume: "",
        specs: "",
      },
      idx2: null,

      isErrorList: [
        {
          val: "1",
          name: "是",
        },
        {
          val: "0",
          name: "否",
        },
      ],

      groupName: "yuDanMuBan",
      templateName: "运单导入模板.xlsx",
      fileNameId: "cc7d93c731c638f8d6aa8c0943150d81.xlsx", //文件id
      fileNameLists: [],

      groupName2: "yuDanHuoWuMuBan",
      templateName2: "运单货物导入模板.xlsx",
      fileNameId2: "", //文件id
      // fileNameId2: "f6a0c36da65743e793cec91aa1df0659.xlsx", //文件id
      fileNameLists2: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      this.tableHeigth = windonHeight - 141 + "px";
      console.log("tableHeigth", this.tableHeigth);
    });
  },
  activated() {},
  destroyed() {},
  methods: {
    // 选择图片
    changeFileList(array) {
      console.log("array", array);
      this.fileNameLists = array;
      let fileName = array[0].name || "";
      this.$API
        .saveExportTemplate({
          groupName: this.groupName || "",
          templateName: this.templateName || "",
          fileName: fileName || this.fileNameId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "上传成功");
        });
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
      let fileName = array[0].name || "";
      this.$API
        .saveExportTemplate({
          groupName: this.groupName2 || "",
          templateName: this.templateName2 || "",
          fileName: fileName || this.fileNameId2,
        })
        .then((res) => {
          this.$message.success(res.data.message || "上传成功");
        });
    },

    downLoadYD(type) {
      let fileNames = "";
      let templateName = "";
      if (type == 1) {
        // 下载运单模板
        fileNames = this.fileNameId;
        templateName = this.templateName;
      } else {
        fileNames = this.fileNameId2;
        templateName = this.templateName2;
      }

      this.$API.wtl_getFileUrl({ fileName: fileNames }).then((res) => {
        console.log(res);

        let downloadurl = res.data.result.url;
        var a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadurl;
        a.target = "_blank";
        a.setAttribute("download", templateName); //指定下载后的文件名，防跳转
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },

    editBtns(row, idx) {
      this.isShowDialog1 = true;
      this.dialogForm1 = JSON.parse(JSON.stringify(row));
      this.idx1 = idx;
    },

    delBtns(row, idx) {
      this.$confirm(
        "确定删除该条数据吗? 运单号为: " + row.waybillNumber,
        "提示:"
      )
        .then((res) => {
          let d = JSON.parse(JSON.stringify(this.tableData));
          d.splice(idx, 1);
          this.tableData = d;
        })
        .catch(() => {});
    },
    editBtns2(row, idx) {
      this.isShowDialog2 = true;
      this.dialogForm2 = JSON.parse(JSON.stringify(row));
      this.idx2 = idx;
    },

    delBtns2(row, idx) {
      this.$confirm(
        "确定删除该条数据吗? 运单号为: " + row.waybillNumber,
        "提示:"
      )
        .then((res) => {
          let d = JSON.parse(JSON.stringify(this.tableData2));
          d.splice(idx, 1);
          this.tableData2 = d;
        })
        .catch(() => {});
    },

    goDetails() {
      if (!this.waybillFile) {
        this.$message.error("请上传运单模板");
        return false;
      }
      // if (!this.itemFile) {
      //   this.$message.error("请上传运单货物模板");
      //   return false;
      // }
      const form = new FormData(); //  根据后台需求数据格式
      // form.append("itemFile", this.itemFile); //  文件对象
      form.append("waybillFile", this.waybillFile); //
      this.$showLoading();
      this.$API.importWaybillV3v2(form).then((res) => {
        this.$hideLoading();
        let datas = res.data.result || "";
        if (datas) {
          this.tableData = datas; //运单信息
          // this.tableData2 = datas.waybillItemInfoList || []; //货物信息
        }
        this.isShowYL = true;
        // this.$router.push({
        //   path: "/WaybillManage/WaybillimportDetail",
        // });
      });
    },

    // 重置
    ResetBtns() {
      this.inputNum = "";
      this.fileName1 = "";
      this.fileName2 = "";
      this.isFileSuccess_1 = false;
      this.isFileSuccess_2 = false;
      this.itemFile = "";
      this.waybillFile = "";
    },

    //  上传
    uploadMaterial(type) {
      this.inputNum = type;
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    // 触发上传材料文件
    getFileData() {
      const inputFile = this.$refs.file.files[0];

      const file = inputFile;
      const fileName = inputFile.name;

      // 运单模板名
      if (this.inputNum == 1) {
        this.isFileSuccess_1 = true;
        this.fileName1 = fileName;
        this.waybillFile = file;
      }
      // 货物模板名
      if (this.inputNum == 2) {
        this.isFileSuccess_2 = true;
        this.fileName2 = fileName;
        this.itemFile = file;
      }
      // const form = new FormData(); //  根据后台需求数据格式
      // form.append("file", file); //  文件对象
      // form.append("fileName", fileName); //  文件名
      // let sign = this.$TOOLS.getSign({ fileName: fileName });
      // form.append("sign", sign);

      // this.$API.uploadFile(form).then((res) => {
      //   let obj = {
      //     name: res.data.result.fileName,
      //     url: res.data.result.url,
      //   };
      //   console.log("obj", obj);
      //   if (this.inputNum == 1) {
      //     this.isFileSuccess_1 = true;
      //
      //   }
      //   if (this.inputNum == 2) {
      //     this.isFileSuccess_2 = true;
      //
      //   }
      // });
    },

    // 预览部分的

    // 确定导入
    saveBtns() {
      let chartsArray = this.tableData.filter((item) => item.errorReason) || [];
      console.log("chartsArray", chartsArray);
      if (chartsArray.length > 0) {
        this.$message.warning("还存在错误的数据,请修改完后重新提交");
        return false;
      }
      this.$API
        .importWaybillSureV3v2({
          waybillInfoList: this.tableData,
          // waybillItemInfoList: this.tableData2,
        })
        .then((res) => {
          let datas = res.data.result || "";
          console.log("res", datas);
          if (datas) {
            this.tableData = datas.waybillInfoList || []; //运单信息
            // this.tableData2 = datas.waybillItemInfoList || []; //货物信息
            this.$message.error(res.data.message || "导入失败");
          } else {
            setTimeout(() => {
              this.isShowYL = false;
            }, 1000);
            this.$message.success(res.data.message || "导入成功");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    // 合并行或者列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 合并行
      if (columnIndex === 2) {
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
    // 表格合计
    getSummaries2(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr2.length; i++) {
          if (column.property === that.totalArr2[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable2.doLayout();
      });
      return sums;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        isError: "",
        errorReason: "",
        waybillNumber: "",
        customerNumber: "",
        customerName: "",
        customerOrderNumber: "",
        businessDeptName: "",
        businessDeptNumber: "",
        transportMethod: "",
        businessDate: "",
        takeTime: "",
        deliveryTime: "",
        receiveMethod: "",
        sendMethod: "",
        requireName: "",
        requireCount: "",
        waybillType: "",
        endDeptName: "",
        endDeptNumber: "",
        waybillRemarks: "",
        receiveContacts: "",
        receiveCompany: "",
        receivePhone: "",
        receiveProvinceName: "",
        receiveCityName: "",
        receiveAreaName: "",
        receiveAddress: "",
        contacts: "",
        company: "",
        tel: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        goodsNumber: "",
        goodsName: "",
        itemCategoryName: "",
        packageName: "",
        packageCout: "",
        grossWeight: "",
        netWeight: "",
        volumeWeight: "",
        billingWeight: "",
        volume: "",
        specs: "",
        unitPrice: "",
        settlementMethod: "",
        isInvoice: "",
        taxes: "",
        basicFreight: "",
        takeFee: "",
        sendFee: "",
        otherFee: "",
        totalFreight: "",
        billingAmount: "",
        agentAmount: "",
        receivedAmount: "",
        customerName: "",
        itemServiceFeeRemarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1(formName) {
      let arrs = [this.dialogForm1];
      this.$API
        .importWaybillCheckV3v2({
          waybillInfoList: arrs,
          // waybillItemInfoList: this.tableData2,
        })
        .then((res) => {
          let datas = JSON.parse(JSON.stringify(this.tableData));
          datas[this.idx1] = res.data.result.waybillInfoList[0];
          this.isShowDialog1 = false;
          this.$nextTick(() => {
            this.tableData = datas;
            this.$refs.mytable.doLayout();
          });
        })
        .catch(() => {});
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        isError: "",
        errorReason: "",
        waybillNumber: "",
        contacts: "",
        company: "",
        tel: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        goodsNumber: "",
        goodsName: "",
        itemCategoryName: "",
        packageName: "",
        packageCout: "",
        grossWeight: "",
        volume: "",
        specs: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      let arrs = [this.dialogForm2];
      this.$API
        .importWaybillCheck({
          waybillInfoList: [],
          waybillItemInfoList: arrs,
        })
        .then((res) => {
          let datas = JSON.parse(JSON.stringify(this.tableData2));
          datas[this.idx2] = res.data.result.waybillItemInfoList[0];
          this.isShowDialog2 = false;

          this.$nextTick(() => {
            this.tableData2 = datas;
            this.$refs.mytable2.doLayout();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang='less'>
@borderd7: #d7d7d7;
.mtb {
  width: 80%;
  margin: 30px auto;
  border: 1px solid @borderd7;
  border-radius: 4px;

  .rows {
    display: flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;

    .rowLeft,
    .rowRight {
      flex: 1;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid @borderd7;
      padding: 0 10px;
    }
    .rowLeft {
      border-right: 1px solid @borderd7;
      text-align: center;
    }
    .rowRight {
      display: flex;
      align-items: center;
      .btns {
        padding: 8px 10px;
      }

      .filenames {
        margin: 0 10px;
        text-decoration: underline;
      }
    }
  }
}

.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.errorClaaa {
  color: #f00;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tablerTitle {
  // width: 90%;
  height: 30px;
  line-height: 30px;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: px solid #fff;
  font-weight: bold;
}

.diaForm {
  /deep/ .el-select {
    width: 100%;
  }
}
</style>